import React from 'react';
import styled from 'styled-components';
import Text from '@components/shared/Text';
import { PageSlice, SliceTextDetails } from '@contracts';

interface Props {
  slice: PageSlice;
}

const TextSlice: React.FC<Props> = ({ slice }) => {
  const slicePrimary = slice.primary as SliceTextDetails;
  const backgroundColor = slicePrimary.background_color || '';
  const backgroundGradient = slicePrimary.background_gradient?.text ?? '';
  const padding = slicePrimary.padding?.text ?? '0';
  const mobilePadding = slicePrimary.mobile_padding?.text ?? padding;
  const maxWidth = slicePrimary.maxwidth?.text ?? '';
  const textAlignMobile = slicePrimary.text_align_mobile ?? '';

  return (
    <Container $backgroundColor={backgroundColor} $backgroundGradient={backgroundGradient} $padding={padding} $mobilePadding={mobilePadding}>
      <Inner $maxWidth={maxWidth} $textAlignMobile={textAlignMobile}>
        <Text
          text={slicePrimary.text.html}
          richText={slicePrimary.text.richText}
          textAlign={slicePrimary.text_align}
          textColor={slicePrimary.text_color}
          fontSize={slicePrimary.font_size}
          fontSizeMobile={slicePrimary.font_size_mobile}
        />
      </Inner>
    </Container>
  );
};

export default TextSlice;

interface ContainerProps {
  $backgroundColor?: string;
  $backgroundGradient?: string;
  $maxWidth?: string;
  $textAlignMobile?: string;
  $padding?: string;
  $mobilePadding?: string;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(props) => props.$padding};
  margin: 0 auto;
  background-color: ${(props) => props.$backgroundColor};
  background-image: ${(props) => (props.$backgroundGradient ? props.$backgroundGradient : 'none')};
  width: 100%;

  @media (max-width: 768px) {
    padding: ${(props) => props.$mobilePadding};
  }
`;

const Inner = styled.div<ContainerProps>`
  max-width: ${(props) => (props.$maxWidth ? props.$maxWidth : '100%')};
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0 20px;

    & > * {
      text-align: ${(props) => (props.$textAlignMobile ? props.$textAlignMobile : 'center')};
    }
  }
`;
